import { render, staticRenderFns } from "./ChooseSpace.vue?vue&type=template&id=6803e9ae"
import script from "./ChooseSpace.vue?vue&type=script&lang=js"
export * from "./ChooseSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports